import clsx from 'clsx';

import { emptyStateMascotImageHover, MASCOT_SLOT } from '@/modules/players/v3/constants/constants';
import type { EmptyMascotSize } from '@/modules/players/v3/types/dashboard';

export type { EmptyMascotSize };

export type DashboardEmptyMascotLayerProps = {
  src: string;
  position: 'bottom-left' | 'bottom-right';
  size?: EmptyMascotSize;
  slotClassName?: string;
  className?: string;
  width?: number;
  height?: number;
};

export const DashboardEmptyMascotLayer = ({
  src,
  position,
  size = 'default',
  slotClassName,
  className: imageClassName,
  width = 120,
  height = 150,
}: DashboardEmptyMascotLayerProps) => {
  return (
    <div
      className={clsx(
        'pointer-events-none absolute bottom-0 z-0',
        slotClassName ?? MASCOT_SLOT[size],
        position === 'bottom-left' ? 'left-0' : 'right-0'
      )}
      aria-hidden
    >
      <img
        src={src}
        alt=''
        width={width}
        height={height}
        className={clsx(
          'h-full w-full min-h-0 min-w-0 object-contain object-bottom select-none',
          position === 'bottom-left' ? 'object-left' : 'object-right',
          emptyStateMascotImageHover(position),
          imageClassName
        )}
      />
    </div>
  );
};
